export const UPLOAD_DIR = {
  ruan: 'ruan/page',
};

export const STATUS_LIST = [
  // 因为后台接口上下架状态值有多种，前端使用on 和 off 来区别
  {
    value: 'on',
    label: '√',
  },
  {
    value: 'off',
    label: '×',
  },
];
